import { render, staticRenderFns } from "./TabArbos.vue?vue&type=template&id=5a0c1d18&"
import script from "./TabArbos.vue?vue&type=script&lang=js&"
export * from "./TabArbos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports